import { cn } from '@immo/ui-kit';
import { GripVerticalIcon } from '../icons';
import { useTranslations } from '../use-translations';

type ColumnGripProps = {
  readonly columnLabel: string;
  readonly onDragStart: () => void;
  readonly onDragEnd: () => void;
  /** The caller owns which `group/…` reveals the grip on hover, and nothing else. */
  readonly className?: string;
};

export function ColumnGrip({ columnLabel, onDragStart, onDragEnd, className }: ColumnGripProps) {
  const t = useTranslations('components.column-preference');

  return (
    <span
      role="button"
      tabIndex={0}
      draggable
      aria-label={t('drag.handle', { column: columnLabel })}
      onDragStart={(event) => {
        event.dataTransfer.effectAllowed = 'move';
        onDragStart();
      }}
      onDragEnd={onDragEnd}
      className={cn(
        'shrink-0 cursor-grab text-text-placeholder opacity-0 transition-opacity',
        'focus-visible:opacity-100 focus-visible:shadow-focus focus-visible:outline-none',
        className,
      )}
    >
      <GripVerticalIcon className="h-3.5 w-3.5" aria-hidden />
    </span>
  );
}
